import { initSelect2Modal, hideModalOn } from './select2_modal'

initSelect2Modal({
  modalId: 'assign-concierge-modal',
  selectId: 'concierge_user_id',
  placeholder: 'Search site reps by name or email…',
})

hideModalOn('closeAssignConciergeModal', '#assign-concierge-modal.show')
